module.exports = "<div id=\"status-chart-chart\" class=\"affix\">\n    <button type=\"button\" class=\"close\" id='status-chart-close' aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/status/chartView.html
// module id = 1035
// module chunks = 7